import { BaseQueryApi, FetchArgs, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getSessionToken } from '@shopify/app-bridge-utils';
import { createApp } from '@shopify/app-bridge';
import { config } from '@/config';
import { EMBEDDED_APP_STATUS } from '@/constants/enum';
import store from '../store';
import { handleGetSessionToken, handleLoadingSessionToken } from '../slice/auth.slice';
import { LocalStorageKey } from '@/constants/storages';

const BASE_URL = process.env.REACT_APP_API_END_POINT;

const params = {
  shop: config.shop,
};

const configApp = {
  apiKey: process.env.REACT_APP_API_KEY || '',
  host: new URLSearchParams(window.location.search).get('host') || '',
  forceRedirect: process.env.REACT_APP_MODE === 'live' && config.scope !== 'omegatheme',

};

const customBaseQuery = () => {
  const baseQuery = fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: async (headers) => {
      if (config.embedded === EMBEDDED_APP_STATUS.EMBEDDED) {
        const {
          sessionToken: { isLoading, token, expiredTime },
        } = store.getState().auth;
        if ((!token || Date.now() > expiredTime) && !isLoading) {
          try {
            store.dispatch(handleLoadingSessionToken(true));
            const app = createApp(configApp);
            const sessionToken = await getSessionToken(app);
            store.dispatch(
              handleGetSessionToken({
                token: sessionToken,
                expiredTime: Date.now() + 60 * 1000,
                isLoading: false,
              }),
            );
            headers.set(LocalStorageKey.SESSION_TOKEN, `Bearer ${sessionToken}`);
          } catch (err) {
            store.dispatch(handleLoadingSessionToken(false));
          }
        }
        if (token) {
          headers.set(LocalStorageKey.SESSION_TOKEN, `Bearer ${token}`);
        }
      }

      if (process.env.REACT_APP_ENV === 'production') {
        headers.set('Content-Security-Policy', `frame-ancestors https://${params.shop} https://admin.shopify.com`);
      }
      headers.set(LocalStorageKey.AUTHORIZATION_URL_PARAM, config.urlParams);
      return headers;
    },
  });
  return async (args: string | FetchArgs, api: BaseQueryApi) => {
    const response = await baseQuery(args, api, {});
    return response;
  };
};

export default customBaseQuery;
